export const FLAGS = {
  BADGE_MIGRATION: false,
};
